module.exports = __webpack_public_path__ + "static/media/huli_410.227556be.gif";